import { jsx as o } from "react/jsx-runtime";
import { isLink as t, BaseButton as i } from "@systemeio/ui";
import { twMerge as m } from "tailwind-merge";
import { useDesignContext as n } from "../providers/use-design-provider.mjs";
const c = (e) => {
  const { isDefaultSioColor: r } = n(), a = t(e) ? e["aria-disabled"] : e.disabled;
  return /* @__PURE__ */ o(
    i,
    {
      color: r ? "text-background-secondary" : "text-THEME-text-primary",
      hoverColor: r ? "hover:text-background-secondary" : "hover:text-THEME-text-primary",
      backgroundColor: r ? "bg-brand-primary" : "bg-THEME-primary",
      hoverBackgroundColor: r ? "hover:bg-brand-primary" : "hover:bg-THEME-primary",
      ...e,
      className: m(
        e.className,
        !r && "ring-THEME-primary",
        a && "bg-text-secondary/50"
      ),
      loaderClassName: r ? "text-background-secondary fill-brand-primary" : "text-THEME-text-primary fill-THEME-primary"
    }
  );
};
export {
  c as default
};
